import { FormsModels } from '../../models/forms.model';

export type EnumValueType = string | number;

export function getEnumNames(e: any): string[] {
  return Object.keys(e).filter((key) => isNaN(+key));
}

export function getEnumValues<T extends EnumValueType>(e: any): T[] {
  return getEnumNames(e).map((name) => e[name]) as T[];
}

export const yesNoSelectList: FormsModels.SelectListItem<boolean>[] = [
  {
    value: false,
    text: 'Non',
  },
  {
    value: true,
    text: 'Oui',
  },
];
